/**
 * Cart Discount Progress Bar
 * Updates the discount progress bar when cart items change
 */
document.addEventListener('DOMContentLoaded', function() {
  // Initialize variables
  let progressBar = null;
  let discountText = null;
  let markers = null;
  let markerLabels = null;
  
  // Constants for discount tiers
  const TIER_1_QTY = 2;
  const TIER_2_QTY = 3;
  const TIER_3_QTY = 5;
  const TIER_1_DISCOUNT = 10;
  const TIER_2_DISCOUNT = 15;
  const TIER_3_DISCOUNT = 25;
  
  /**
   * Initialize all required elements
   * This ensures we don't try to use elements that don't exist
   */
  function initElements() {
    progressBar = document.querySelector('.discount-progress-bar__progress');
    discountText = document.querySelector('.discount-progress-bar__discount-text');
    markers = document.querySelectorAll('.discount-progress-bar__marker');
    markerLabels = document.querySelectorAll('.discount-progress-bar__marker-label');
    
    // initialization summary removed (quiet mode)
    
    // Return true if all required elements are found
    return !!(progressBar && discountText && markers.length && markerLabels.length);
  }
  
  /**
   * Update the progress bar based on cart quantity
   */
  function updateProgressBar(totalQuantity) {
    if (!initElements()) {
      // console.error('Required elements not found for cart discount progress bar');
      return;
    }
    
    // console.log('Updating progress bar with quantity:', totalQuantity);
    
    let currentTier = 0;
    let currentDiscount = 0;
    let nextTierQty = 0;
    let nextDiscount = 0;
    let progressPercentage = 0;
    
    // Determine current tier
    if (totalQuantity >= 5) {
      currentTier = 3;
      currentDiscount = TIER_3_DISCOUNT;
    } else if (totalQuantity >= 3) {
      currentTier = 2;
      currentDiscount = TIER_2_DISCOUNT;
      nextTierQty = 5;
      nextDiscount = TIER_3_DISCOUNT;
    } else if (totalQuantity >= 2) {
      currentTier = 1;
      currentDiscount = TIER_1_DISCOUNT;
      nextTierQty = 3;
      nextDiscount = TIER_2_DISCOUNT;
    } else {
      currentTier = 0;
      nextTierQty = 2;
      nextDiscount = TIER_1_DISCOUNT;
    }

    // Discrete progress mapping
    const progressMap = {0:0,1:14,2:39,3:64,4:75};
    progressPercentage = totalQuantity >=5 ? 100 : (progressMap[totalQuantity] ?? 0);
    
    // Update the progress bar width
    progressBar.style.width = `${progressPercentage}%`;
    
    // Update marker active states
    markers.forEach((marker, index) => {
      if (index <= currentTier) {
        marker.classList.add('active');
      } else {
        marker.classList.remove('active');
      }
    });
    
    // Update marker label active states
    markerLabels.forEach((label, index) => {
      if (index === currentTier) {
        label.classList.add('active');
      } else {
        label.classList.remove('active');
      }
    });
    
    // Get translation strings
    const addMoreText = document.querySelector('.discount-progress-bar').dataset.addMoreText || 'Add {{ quantity }} more to get {{ discount }}% discount!';
    const currentDiscountText = document.querySelector('.discount-progress-bar').dataset.currentDiscountText || 'You now have {{ discount }}% discount! Add {{ next_quantity }} more to get {{ next_discount }}% discount.';
    const maxDiscountText = document.querySelector('.discount-progress-bar').dataset.maxDiscountText || 'You now have the maximum discount: {{ discount }}%!';
    
    // Update discount text
    if (currentTier === 0) {
      const itemsToAdd = TIER_1_QTY - totalQuantity;
      discountText.innerHTML = `<span class="emoji">🎯</span> Lisää vielä ${itemsToAdd} pari${itemsToAdd > 1 ? 'a' : ''} – saat <span class="discount-bold">–${TIER_1_DISCOUNT} %</span>!`;
    } else if (currentTier === 1) {
      const itemsToAdd = nextTierQty - totalQuantity;
      discountText.innerHTML = `<span class="emoji">✅</span> Saat nyt <span class="discount-bold">–${TIER_1_DISCOUNT} %</span> alennuksen<br><span class="emoji">🎯</span> Lisää vielä ${itemsToAdd} pari${itemsToAdd > 1 ? 'a' : ''} – saat <span class="discount-bold">–${TIER_2_DISCOUNT} %</span>!`;
    } else if (currentTier === 2) {
      const itemsToAdd = nextTierQty - totalQuantity;
      discountText.innerHTML = `<span class="emoji">✅</span> Saat nyt <span class="discount-bold">–${TIER_2_DISCOUNT} %</span> alennuksen<br><span class="emoji">🎯</span> Lisää vielä ${itemsToAdd} pari${itemsToAdd > 1 ? 'a' : ''} – saat <span class="discount-bold">–${TIER_3_DISCOUNT} %</span>!`;
    } else if (currentTier === 3) {
      discountText.innerHTML = `<span class="emoji">✅</span> Saat nyt <span class="discount-bold">–${TIER_3_DISCOUNT} %</span> alennuksen`;
    }
  }
  
  /**
   * Fetch cart data and update progress bar
   */
  function fetchCartAndUpdateProgressBar() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateProgressBar(cart.item_count);
      })
      .catch(() => {});
  }
  
  // Update on page load
  fetchCartAndUpdateProgressBar();
  
  // Listen for cart update events
  document.addEventListener('cart:updated', fetchCartAndUpdateProgressBar);
  document.addEventListener('cart:refresh', fetchCartAndUpdateProgressBar);
  
  // Listen for cart drawer open event
  document.addEventListener('drawer:open', function(event) {
    if (event.detail?.drawer === 'cart') {
      setTimeout(fetchCartAndUpdateProgressBar, 100);
    }
  });
  
  // Listen for quantity input changes
  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('quantity__input')) {
      setTimeout(fetchCartAndUpdateProgressBar, 300);
    }
  });

  // Listen for clicks on plus / minus quantity buttons
  document.addEventListener('click', function(event) {
    if (event.target.closest('.quantity__button')) {
      // Wait a short moment for Shopify JS to update cart, then refresh
      setTimeout(fetchCartAndUpdateProgressBar, 500);
    }
  });

  // Listen for cart item removals (buttons with name="updates[]" value="0" or remove links)
  document.addEventListener('click', function(event) {
    if (event.target.matches('[name="updates[]"][value="0"]') || event.target.closest('[data-cart-remove]')) {
      setTimeout(fetchCartAndUpdateProgressBar, 500);
    }
  });

  // Subscribe to Shopify's PUB_SUB cart events if available
  if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCartAndUpdateProgressBar);
  }

  // Fallback: observe cart DOM mutations
  const cartContainer = document.querySelector('cart-drawer, cart-items, #CartDrawer-CartItems');
  if (cartContainer) {
    const observer = new MutationObserver(() => {
      fetchCartAndUpdateProgressBar();
    });
    observer.observe(cartContainer, { childList: true, subtree: true });
  }
});
